/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChefEntrepriseSiegeSocialGridDto
 */
export interface ChefEntrepriseSiegeSocialGridDto {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    idchefEntreprise?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSiegeSocialGridDto
     */
    numeroBce?: string | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSiegeSocialGridDto interface.
 */
export function instanceOfChefEntrepriseSiegeSocialGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSiegeSocialGridDtoFromJSON(json: any): ChefEntrepriseSiegeSocialGridDto {
    return ChefEntrepriseSiegeSocialGridDtoFromJSONTyped(json, false);
}

export function ChefEntrepriseSiegeSocialGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSiegeSocialGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'numeroBce': !exists(json, 'numeroBce') ? undefined : json['numeroBce'],
    };
}

export function ChefEntrepriseSiegeSocialGridDtoToJSON(value?: ChefEntrepriseSiegeSocialGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocial': value.idsiegeSocial,
        'idchefEntreprise': value.idchefEntreprise,
        'nom': value.nom,
        'email': value.email,
        'gsm': value.gsm,
        'telephone': value.telephone,
        'numeroBce': value.numeroBce,
    };
}

